// Shared on-demand loader for GSAP + ScrollTrigger, for desktop-only effects
// that shouldn't put GSAP in the initial bundle of every device.
type GsapModules = {
  gsap: typeof import("gsap").default;
  ScrollTrigger: typeof import("gsap/ScrollTrigger").ScrollTrigger;
};

let promise: Promise<GsapModules> | null = null;

export function loadScrollTrigger(): Promise<GsapModules> {
  promise ??= Promise.all([import("gsap"), import("gsap/ScrollTrigger")]).then(
    ([gsapModule, scrollTriggerModule]) => {
      const gsap = gsapModule.default;
      const { ScrollTrigger } = scrollTriggerModule;
      gsap.registerPlugin(ScrollTrigger);
      return { gsap, ScrollTrigger };
    },
  );
  return promise;
}
